import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Header from '../../Header';
import Footer from '../../Footer';
import config from "../../common/Config";
import { toast } from 'sonner';
import { Box, Typography, TextField, Button, Paper, Grid2 } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { parse, format, isValid } from 'date-fns';
import { axiosPostSupplierMultipart } from '../../../utils/supplierApi';


const Add_Supplier = () => {
  const accessToken = localStorage.getItem('accessToken');
  const token = localStorage.getItem("token");
  const navigateToSupplierList = useNavigate();
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    company: '',
    name: '',
    email: '',
    phone: '',
    contact_person: '',
    contact_person_mob: '',
    contact_person_email: '',
    finance_person: '',
    finance_person_mob: '',
    new_arrival: '0',
    is_discount_allow: '0',
    tpd_license_validity: '',
    awrs_license_validity: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const validateForm = () => {
    const newErrors = {};

    // Company validation
    if (!formData.company) {
      newErrors.company = "Mention company Name.";
    } else if (formData.company.length < 2) {
      newErrors.company = "Company name must consist of at least 2 characters.";
    } else if (formData.company.length > 255) {
      newErrors.company = "Company name must not exceed 255 characters.";
    }

    // Name validation
    if (!formData.name) {
      newErrors.name = "Mention Name.";
    } else if (formData.name.length < 2) {
      newErrors.name = "Name must consist of at least 2 characters.";
    } else if (formData.name.length > 255) {
      newErrors.name = "Name must not exceed 255 characters.";
    }

    // Phone validation
    if (!formData.phone) {
      newErrors.phone = "Phone is Required.";
    } else if (!/^\d{10,12}$/.test(formData.phone)) {
      newErrors.phone = "Phone number must be between 10 and 12 digits.";
    }

    // Email validation
    if (!formData.email) {
      newErrors.email = "Mention Email Id.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Please enter a valid email.";
    }

    // Contact person validation
    if (!formData.contact_person) {
      newErrors.contact_person = "Mention person Name.";
    } else if (formData.contact_person.length < 2) {
      newErrors.contact_person = "Contact person name must consist of at least 2 characters.";
    } else if (formData.contact_person.length > 255) {
      newErrors.contact_person = "Contact person name must not exceed 255 characters.";
    }

    // Contact person mobile validation
    if (!formData.contact_person_mob) {
      newErrors.contact_person_mob = "Contact person mobile is Required.";
    } else if (!/^\d{10,12}$/.test(formData.contact_person_mob)) {
      newErrors.contact_person_mob = "Contact person mobile must be between 10 and 12 digits.";
    }

    // Contact person email validation
    if (!formData.contact_person_email) {
      newErrors.contact_person_email = "Mention Contact Person Email.";
    } else if (!/\S+@\S+\.\S+/.test(formData.contact_person_email)) {
      newErrors.contact_person_email = "Please enter a valid contact person email.";
    }

    // Finance person validation
    if (!formData.finance_person) {
      newErrors.finance_person = "Mention Finance Person Name.";
    } else if (formData.finance_person.length < 2) {
      newErrors.finance_person = "Finance person name must consist of at least 2 characters.";
    } else if (formData.finance_person.length > 255) {
      newErrors.finance_person = "Finance person name must not exceed 255 characters.";
    }


    if (!formData.finance_person_mob) {
      newErrors.finance_person_mob = "finance mobile is Required.";
    } else if (!/^\d{10,12}$/.test(formData.finance_person_mob)) {
      newErrors.finance_person_mob = "finance person mobile must be between 10 and 12 digits.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    let fieldErrors = {};

    // Validate the input field immediately as the user types
    switch (name) {
      case 'company':
        if (!value) {
          fieldErrors.company = "Mention company Name.";
        } else if (value.length < 2) {

          fieldErrors.company = "Company name must consist of at least 2 characters.";
        } else if (value.length > 255) {
          fieldErrors.company = "Company name must not exceed 255 characters.";
        }

        // Clear error if all conditions are met
        if (!fieldErrors.company) {
          //delete fieldErrors.company;
          fieldErrors.company = '';
        }
        break;

      case 'name':
        if (!value) {
          fieldErrors.name = "Mention Name.";
        } else if (value.length < 2) {
          fieldErrors.name = "Name must consist of at least 2 characters.";
        } else if (value.length > 255) {
          fieldErrors.name = "Name must not exceed 25 characters.";
        }
        if (!fieldErrors.name) {
          fieldErrors.name = '';
        }
        break;

      case 'phone':
        if (!value) {
          fieldErrors.phone = "Phone is Required.";
        } else if (!/^\d{10,12}$/.test(value)) {
          fieldErrors.phone = "Phone number must be between 10 and 12 digits.";
        }
        if (!fieldErrors.phone) {

          fieldErrors.phone = '';
        }
        break;

      case 'email':
        if (!value) {
          fieldErrors.email = "Mention Email Id.";
        } else if (!/\S+@\S+\.\S+/.test(value)) {
          fieldErrors.email = "Please enter a valid email.";
        }
        if (!fieldErrors.email) {
          fieldErrors.email = '';
        }
        break;

      case 'contact_person':
        if (!value) {
          fieldErrors.contact_person = "Mention person Name.";
        } else if (value.length < 2) {
          fieldErrors.contact_person = "Contact person name must consist of at least 2 characters.";
        } else if (value.length > 255) {
          fieldErrors.contact_person = "Contact person name must not exceed 255 characters.";
        }
        if (!fieldErrors.contact_person) {
          fieldErrors.contact_person = '';
        }
        break;

      case 'contact_person_mob':
        if (!value) {
          fieldErrors.contact_person_mob = "Contact person mobile is Required.";
        } else if (!/^\d{10,12}$/.test(value)) {
          fieldErrors.contact_person_mob = "Contact person mobile must be between 10 and 12 digits.";
        }
        if (!fieldErrors.contact_person_mob) {
          fieldErrors.contact_person_mob = '';
        }
        break;

      case 'contact_person_email':
        if (!value) {
          fieldErrors.contact_person_email = "Mention Contact Person Email.";
        } else if (!/\S+@\S+\.\S+/.test(value)) {
          fieldErrors.contact_person_email = "Please enter a valid contact person email.";
        }
        if (!fieldErrors.contact_person_email) {
          fieldErrors.contact_person_email = '';
        }
        break;

      case 'finance_person':
        if (!value) {
          fieldErrors.finance_person = "Mention Finance Person Name.";
        } else if (value.length < 2) {
          fieldErrors.finance_person = "Finance person name must consist of at least 2 characters.";
        } else if (value.length > 255) {
          fieldErrors.finance_person = "Finance person name must not exceed 255 characters.";
        }
        if (!fieldErrors.finance_person) {
          fieldErrors.finance_person = '';
        }
        break;

      case 'finance_person_mob':
        if (!value) {
          fieldErrors.finance_person_mob = "Contact person mobile is Required.";
        } else if (!/^\d{10,12}$/.test(value)) {
          fieldErrors.finance_person_mob = "Contact person mobile must be between 10 and 12 digits.";
        }
        if (!fieldErrors.finance_person_mob) {
          fieldErrors.finance_person_mob = '';
        }
        break;

      default:
        break;
    }

    // Update errors state for the specific field
    setErrors((prevErrors) => ({
      ...prevErrors,
      ...fieldErrors
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: checked ? '1' : '0', // Set '1' if checked, null if unchecked
    }));
  };

  const submitSalesOrderForm = async () => {
    if (!validateForm()) return;
    setIsSubmitting(true);
    const form = document.getElementById('addsupplierform');
    const formDataToSend = new FormData(form);
    try {
      const result = await axiosPostSupplierMultipart(
        `${config.API_URL}/add_supplier`,
        token,
        formDataToSend
      );
      if (result.success == true) {
        toast.success("Supplier added successfully.");
        setTimeout(() => {
          navigateToSupplierList(`/supplier/`);
        }, 1000);
      } else {
        toast.error("Supplier add Failed. Try Again");
      }
    } catch (error) {
      if (error.message === 'ENCRYPT_KEY_MISSING') {
        toast.error('Encryption key missing.');
      } else {
        toast.error("An error occurred while adding supplier.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }
    //navigateToSupplierList(`/supplier/`);
  }, []);

  return (
    <>
      <Header />
      <Box sx={{ p: 3 }}>
        <Box sx={{ mb: 2 }}>
          <Typography variant="h5" sx={{ fontWeight: 600, mb: 0.5 }}>Add Suppl</Typography>
        </Box>
        <Paper elevation={0} sx={{ p: 3, borderRadius: 2, border: '1px solid rgba(145, 158, 171, 0.16)' }}>
          <Typography sx={{ fontWeight: 500, mb: 1, pb: 0.5, borderBottom: '1px solid rgba(145, 158, 171, 0.16)' }}>
            Note : Fields marked with a red asterisk (*) are mandatory
          </Typography>
          <form id='addsupplierform'>
            <Grid2 container spacing={3}>
              <Grid2 size={{ xs: 12 }}>
                <Typography variant="subtitle2" sx={{ mb: 1.5, pb: 0.5, borderBottom: '1px solid rgba(145, 158, 171, 0.16)', fontWeight: 600, fontSize: '14px' }}>
                  Company Detail
                </Typography>
                <Grid2 container spacing={2}>
                  <Grid2 size={{ xs: 12, md: 3 }}>
                    <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>
                      Company <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      size="small"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      error={!!errors.company}
                      helperText={errors.company}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 3 }}>
                    <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>
                      Name <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      size="small"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      error={!!errors.name}
                      helperText={errors.name}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 3 }}>
                    <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>
                      Email Address <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      size="small"
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      error={!!errors.email}
                      helperText={errors.email}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 3 }}>
                    <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>
                      Phone <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      size="small"
                      type="number"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      onWheel={(e) => e.target.blur()}
                      error={!!errors.phone}
                      helperText={errors.phone}
                    />
                  </Grid2>
                </Grid2>
              </Grid2>

              <Grid2 size={{ xs: 12 }}>
                <Typography variant="subtitle2" sx={{ mb: 1.5, pb: 0.5, borderBottom: '1px solid rgba(145, 158, 171, 0.16)', fontWeight: 600, fontSize: '14px', mt: 2 }}>
                  Address Details
                </Typography>
                <Grid2 container spacing={2}>
                  <Grid2 size={{ xs: 12, md: 4 }}>
                    <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>Address</Typography>
                    <TextField
                      fullWidth
                      size="small"
                      name="address"
                      multiline
                      rows={3}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 2 }}>
                    <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>City</Typography>
                    <TextField fullWidth size="small" name="city" />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 2 }}>
                    <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>State</Typography>
                    <TextField fullWidth size="small" name="state" />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 2 }}>
                    <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>Country</Typography>
                    <TextField fullWidth size="small" name="country" />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 2 }}>
                    <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>Postal Code</Typography>
                    <TextField fullWidth size="small" name="postal_code" />
                  </Grid2>
                </Grid2>
              </Grid2>

              <Grid2 size={{ xs: 12 }}>
                <Typography variant="subtitle2" sx={{ mb: 1.5, pb: 0.5, borderBottom: '1px solid rgba(145, 158, 171, 0.16)', fontWeight: 600, fontSize: '14px', mt: 2 }}>
                  Contact Person
                </Typography>
                <Grid2 container spacing={2}>
                  <Grid2 size={{ xs: 12, md: 4 }}>
                    <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>
                      Name<span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      size="small"
                      name="contact_person"
                      value={formData.contact_person}
                      onChange={handleChange}
                      error={!!errors.contact_person}
                      helperText={errors.contact_person}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 4 }}>
                    <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>
                      Phone <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      size="small"
                      type="number"
                      name="contact_person_mob"
                      value={formData.contact_person_mob}
                      onChange={handleChange}
                      onWheel={(e) => e.target.blur()}
                      error={!!errors.contact_person_mob}
                      helperText={errors.contact_person_mob}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 4 }}>
                    <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>
                      Email <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      size="small"
                      type="email"
                      name="contact_person_email"
                      value={formData.contact_person_email}
                      onChange={handleChange}
                      error={!!errors.contact_person_email}
                      helperText={errors.contact_person_email}
                    />
                  </Grid2>
                </Grid2>
              </Grid2>

              <Grid2 size={{ xs: 12 }}>
                <Typography variant="subtitle2" sx={{ mb: 1.5, pb: 0.5, borderBottom: '1px solid rgba(145, 158, 171, 0.16)', fontWeight: 600, fontSize: '14px', mt: 2 }}>
                  Banking & Finance Details
                </Typography>
                <Grid2 container spacing={2}>
                  <Grid2 size={{ xs: 12, md: 3 }}>
                    <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>
                      Financial Person Name <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      size="small"
                      name="finance_person"
                      value={formData.finance_person}
                      onChange={handleChange}
                      error={!!errors.finance_person}
                      helperText={errors.finance_person}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 3 }}>
                    <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>
                      Financial Person Mobile <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      size="small"
                      type="number"
                      name="finance_person_mob"
                      value={formData.finance_person_mob}
                      onChange={handleChange}
                      onWheel={(e) => e.target.blur()}
                      error={!!errors.finance_person_mob}
                      helperText={errors.finance_person_mob}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 3 }}>
                    <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>Financial Person Email</Typography>
                    <TextField fullWidth size="small" type="email" name="finance_person_email" />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 3 }}>
                    <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>{localStorage.getItem("company_tax_type") || "Vat"} Number</Typography>
                    <TextField fullWidth size="small" name="vat_no" />
                  </Grid2>
                </Grid2>
                <Grid2 container spacing={2} sx={{ mt: 1 }}>
                  <Grid2 size={{ xs: 12, md: 3 }}>
                    <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>Bank Name</Typography>
                    <TextField fullWidth size="small" name="supplier_bank_name" />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 3 }}>
                    <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>Branch Name</Typography>
                    <TextField fullWidth size="small" name="supplier_branch_name" />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 3 }}>
                    <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>Bank Account Number</Typography>
                    <TextField fullWidth size="small" name="supplier_account_number" />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 3 }}>
                    <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>Branch Code</Typography>
                    <TextField fullWidth size="small" name="supplier_branch_code" />
                  </Grid2>
                </Grid2>
              </Grid2>

              <Grid2 size={{ xs: 12 }}>
                <Typography variant="subtitle2" sx={{ mb: 1.5, pb: 0.5, borderBottom: '1px solid rgba(145, 158, 171, 0.16)', fontWeight: 600, fontSize: '14px', mt: 2 }}>
                  Licence Details
                </Typography>
                <Grid2 container spacing={2}>
                  <Grid2 size={{ xs: 12, md: 6 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                      <input
                        type="checkbox"
                        name="new_arrival"
                        id="tobacco"
                        checked={formData.new_arrival === '1'}
                        onChange={handleCheckboxChange}
                        value="1"
                      />
                      <Typography variant="body2" component="label" htmlFor="tobacco" sx={{ cursor: 'pointer' }}>Tobacco Product</Typography>
                    </Box>
                    {formData.new_arrival === '1' && (
                      <Paper variant="outlined" sx={{ p: 2, borderRadius: 1, mt: 1 }}>
                        <Grid2 container spacing={2}>
                          <Grid2 size={{ xs: 12, md: 6 }}>
                            <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>TPD License Number</Typography>
                            <TextField fullWidth size="small" name="tpd_license_no" />
                          </Grid2>
                          <Grid2 size={{ xs: 12, md: 6 }}>
                            <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>TPD License Validity Till Date</Typography>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <DatePicker
                                value={formData.tpd_license_validity ? (isValid(parse(formData.tpd_license_validity, 'yyyy-MM-dd', new Date())) ? parse(formData.tpd_license_validity, 'yyyy-MM-dd', new Date()) : null) : null}
                                onChange={(newValue) => {
                                  const formattedDate = newValue ? format(newValue, 'yyyy-MM-dd') : '';
                                  setFormData({ ...formData, tpd_license_validity: formattedDate });
                                }}
                                slotProps={{
                                  textField: {
                                    size: 'small',
                                    fullWidth: true,
                                    name: 'tpd_license_validity',
                                    id: 'tpd_license_validity',
                                  }
                                }}
                              />
                            </LocalizationProvider>
                            <input type="hidden" name="tpd_license_validity" value={formData.tpd_license_validity} />
                          </Grid2>
                        </Grid2>
                      </Paper>
                    )}
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 6 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                      <input
                        type="checkbox"
                        name="is_discount_allow"
                        id="alcohol"
                        checked={formData.is_discount_allow === '1'}
                        onChange={handleCheckboxChange}
                        value="1"
                      />
                      <Typography variant="body2" component="label" htmlFor="alcohol" sx={{ cursor: 'pointer' }}>Alcohol Licence</Typography>
                    </Box>
                    {formData.is_discount_allow === '1' && (
                      <Paper variant="outlined" sx={{ p: 2, borderRadius: 1, mt: 1 }}>
                        <Grid2 container spacing={2}>
                          <Grid2 size={{ xs: 12, md: 6 }}>
                            <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>AWRS License Number</Typography>
                            <TextField fullWidth size="small" name="awrs_license_no" />
                          </Grid2>
                          <Grid2 size={{ xs: 12, md: 6 }}>
                            <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>AWRS License Validity Till Date</Typography>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <DatePicker
                                value={formData.awrs_license_validity ? (isValid(parse(formData.awrs_license_validity, 'yyyy-MM-dd', new Date())) ? parse(formData.awrs_license_validity, 'yyyy-MM-dd', new Date()) : null) : null}
                                onChange={(newValue) => {
                                  const formattedDate = newValue ? format(newValue, 'yyyy-MM-dd') : '';
                                  setFormData({ ...formData, awrs_license_validity: formattedDate });
                                }}
                                slotProps={{
                                  textField: {
                                    size: 'small',
                                    fullWidth: true,
                                    name: 'awrs_license_validity',
                                    id: 'awrs_license_validity',
                                  }
                                }}
                              />
                            </LocalizationProvider>
                            <input type="hidden" name="awrs_license_validity" value={formData.awrs_license_validity} />
                          </Grid2>
                        </Grid2>
                      </Paper>
                    )}
                  </Grid2>
                </Grid2>
              </Grid2>

              <Grid2 size={{ xs: 12 }}>
                <Box sx={{ textAlign: 'center', mt: 3 }}>
                  <Button
                    variant="contained"
                    onClick={submitSalesOrderForm}
                    disabled={isSubmitting}
                    sx={{ px: 4,
                      backgroundColor: "#F8991D",
                      "&:hover": {
                        backgroundColor: "#F8991D",
                        boxShadow: "none",
                      },
                    }}
                  >
                    {isSubmitting ? 'Adding...' : 'Add Supplier'}
                  </Button>
                </Box>
              </Grid2>
            </Grid2>
          </form>
        </Paper>
      </Box>
    </>
  );
};

export default Add_Supplier; 
